<script>
import InputGroup from "@/components/_Shared/InputGroup";
import { mapState, mapActions } from "vuex";
import { event } from "vue-analytics";

export default {
  props: {
    address: {
      type: Object,
      required: true
    }
  },

  components: {
    InputGroup
  },

  data() {
    return {
      query: null,
      preloader: false
    };
  },
  methods: {
    ...mapActions("newOrder", ["setProfessionalsAvailable", "setProfessional"]),
    ...mapActions("professionals", ["getAvailablesOnDistrictByName"]),
    async search() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          event(
            "cliente",
            "click",
            `Compra:Escolha:PorProfissional:BuscarProfissional=${this.query}`
          );
          let data = {
            query: this.query,
            district_id: this.address.district.id
          };

          let professionals = await this.getAvailablesOnDistrictByName(data);

          this.setProfessionalsAvailable(professionals);
          this.setProfessional(null);
        }
      } catch (e) {
        event(
          "cliente",
          "click",
          `Compra:Escolha:PorProfissional:BuscarProfissionalInvalido=${
            this.query
          }`
        );
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div id="professionals" class="section mb-10">
    <div class="section-title">
      BUSQUE UM PROFISSIONAL
      <hr />
    </div>

    <div class="section-body">
      <div class="form-group">
        <InputGroup
          :error="errors.first('busca')"
          v-validate.disabled="'required|min:3'"
          v-model="query"
          name="busca"
          label="digite o nome do profissional"
          custom-classes="capitalize"
          @keyupEnter="search"
        />

        <div @click="search" class="btn bg-purple btn-search" :class="{'btn--loading': preloader}">
          <span>
            <img src="/static/search_white.svg" height="13px" alt="buscar" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-search {
  height: 20px !important;
  padding: 10px 15px;
  margin: 0;
}

.form-group {
  flex-direction: row !important;
  align-items: flex-end;
}

.section-body {
  width: 300px;
  display: flex;
  flex-direction: column;
}

@media (max-width: 468px) {
  .section-body {
    width: 100%;
  }

  .btn-search {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/SearchProfessionals.vue